import client from '@/http'

class Account {
  _path = 'account'

  async fetch(params = null) {
    return await client.get(params ? `${this._path}/${params.path}/${params.token}` : this._path)
  }

  async save(payload, query = null) {
    return await client.put(query ? `${this._path}/${query}` : this._path, payload)
  }
}

export default Account
